// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YT76YAsowoz4bOA9Kfq5{display:flex;align-items:center;gap:8px}.BFw8QkA7344gavTL3xs5{margin-left:4px;cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/entities/QuietHours/ui/QuietHoursSettingsCard/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA,CAGF,sBACE,eAAA,CACA,cAAA","sourcesContent":[".title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.link {\n  margin-left: 4px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `YT76YAsowoz4bOA9Kfq5`,
	"link": `BFw8QkA7344gavTL3xs5`
};
export default ___CSS_LOADER_EXPORT___;
